const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class TestPreguntaApi {
  async getAllTestpregunta(modulo_id) {
    // 1. Get the test for this modulo
    const testRes = await fetch(api(`test/${modulo_id}`));
    if (!testRes.ok) throw new Error(`test fetch: ${testRes.status}`);
    const testData = await testRes.json();
    const test = Array.isArray(testData) ? testData[0] : testData;
    if (!test?.id) return [];

    // 2. Get all questions for that test
    const pregRes = await fetch(api(`pregunta/${test.id}`));
    if (!pregRes.ok) throw new Error(`pregunta fetch: ${pregRes.status}`);
    return pregRes.json();
  }
}
